import { createStore } from 'redux';
import rootReducer from '../reducers/root';

export default function configureStore(initialState) {
  const store = createStore(
    rootReducer,
    initialState,
    window.devToolsExtension ? window.devToolsExtension() : f => f
  );

  return store;
}



/** WEBPACK FOOTER **
 ** ./web/js/libs/configureStore.js
 **/